import React from 'react';
import Page from '../components/Page';
import NotificationSystem from 'react-notification-system';
import { NOTIFICATION_SYSTEM_STYLE } from '../utils/constants';
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Label,
  Row,
  Form,
  FormFeedback,
  FormGroup,
  FormText,
  Input,
  Table,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  ButtonGroup,
} from 'reactstrap';
import { Redirect } from 'react-router';
import StorageService from '../services/StorageService';
import axios from '../utils/posAxios';
import moment from 'moment-timezone';
import OrderItem from '../components/OrderItem';
import OrderPayment from '../components/OrderPayment';
import OrderTax from '../components/OrderTax';
import classnames from 'classnames';
import ContractTable from '../components/ContractTable';
import RecordTable from '../components/RecordTable';
import { MdDone } from 'react-icons/md';

class PosOrderContractDetailPage extends React.Component {
  _isMounted = true;
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      isLoading: true,
      store_id: this.props.match.params.id,
      data_id: this.props.match.params.data_id,
      product_id: this.props.match.params.product_id,
      customer: {},
      data: {},
      contract: [],
      record: [],
      activeTab: '1',
      tabList: [{ name: 'Contract' }, { name: 'Record' }],
      selectedId: '',
      selectedSession: '',
      selectedDate: '',
    };
  }

  toggle = (id, selectedSession, selectedDate) => () => {
    return this.setState({
      modal: !this.state.modal,
      selectedId: id ? id : '',
      selectedSession: selectedSession ? selectedSession : '',
      selectedDate: selectedDate ? selectedDate : '',
    });
  };

  changeHandler = e => {
    let { name, value } = e.target;
    this.setState({
      [name]: value,
    });
  };

  componentDidMount() {
    this.getData();
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  getData = () => {
    const user = StorageService.getSession('user_info');
    const comp = StorageService.getSession('selected_org');
    const url = process.env.REACT_APP_UNITY_API2_URL;

    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      data_id: this.state.data_id,
      product_id: this.state.product_id,
    };

    axios
      .post(url + ':3003/v1/order/contract/detail', data)
      .then(response => {
        const result = response.data;
        if (result.error == true && result.message != 'Success') {
          alert(result.message);
          return;
        }
        if (this._isMounted) {
          console.log(result.data);
          this.setState({
            isLoading: false,
            customer: result.data.customer,
            data: result.data.data,
            contract: result.data.contract,
            record: result.data.record,
          });
        }
      })
      .catch(error => {
        alert(error);
      });
  };

  handleSubmit = e => {
    e.preventDefault();
    const user = StorageService.getSession('user_info');
    const comp = StorageService.getSession('selected_org');
    const url = process.env.REACT_APP_UNITY_API2_URL;

    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      store_id: this.state.store_id,
      order_id: this.state.selectedId,
      left_sessions: this.state.selectedSession,
      end_dt: this.state.selectedDate,
      updated_by: user.email,
    };

    axios
      .post(url + ':3003/v1/order/contract/detail/update', data)
      .then(response => {
        const result = response.data;
        if (result.error == true && result.message != 'Success') {
          alert(result.message);
          return;
        }

        this.notificationSystem.addNotification({
          title: <MdDone />,
          message: 'Contract updated successfully.',
          level: 'success',
          position: 'br',
          autoDismiss: 2,
          dismissible: 'click',
        });
        this.setState({
          modal: false,
        });
        this.getData();
      })
      .catch(error => {
        alert(error);
      });
  };

  toggleTab(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab,
      });
    }
  }

  render() {
    console.log(this.state);
    const { activeTab, customer, data, contract, record } = this.state;
    return (
      <Page
        className="PosOrderContractDetailPage"
        title="Contract Detail"
        breadcrumbs={[
          { name: 'Store', active: false, path: '/posorder' },
          {
            name: 'Order',
            active: false,
            path: '/posorder/store/' + this.state.store_id,
          },
          { name: 'Detail', active: true, path: '' },
        ]}
      >
        <NotificationSystem
          dismissible={false}
          ref={notificationSystem =>
            (this.notificationSystem = notificationSystem)
          }
          style={NOTIFICATION_SYSTEM_STYLE}
        />

        <Row>
          <Col xl={12} lg={12} md={12}>
            <Card className="ps-card-display">
              <CardHeader className="d-flex align-items-center justify-content-between ps-bg-gradient">
                Customer Information
              </CardHeader>
              <CardBody>
                <Row form>
                  <Col lg={4}>
                    <Label>Category</Label>
                    <p>{customer.category}</p>
                  </Col>
                  <Col lg={4}>
                    <Label>Membership ID</Label>
                    <p>{customer.membership_id}</p>
                  </Col>
                  <Col lg={4}>
                    <Label>Name</Label>
                    <p>{customer.name}</p>
                  </Col>
                  <Col lg={4}>
                    <Label>Company</Label>
                    <p>{customer.company}</p>
                  </Col>
                  <Col lg={4}>
                    <Label>Contact</Label>
                    <p>{customer.contact}</p>
                  </Col>
                  <Col lg={4}>
                    <Label>Email</Label>
                    <p>{customer.email}</p>
                  </Col>
                  <Col lg={4}>
                    <Label>Billing Address</Label>
                    <p>{customer.billing_address}</p>
                  </Col>
                  <Col lg={4}>
                    <Label>Billing Unit</Label>
                    <p>{customer.billing_unit}</p>
                  </Col>
                  <Col lg={4}>
                    <Label>Billing Country</Label>
                    <p>{customer.billing_country}</p>
                  </Col>
                  <Col lg={4}>
                    <Label>Billing Postal Code</Label>
                    <p>{customer.billing_postal_code}</p>
                  </Col>
                  <Col lg={4}>
                    <Label>Date of Birth</Label>
                    <p>{customer.dob}</p>
                  </Col>
                  <Col lg={4}>
                    <Label>Remarks</Label>
                    <p>{customer.remarks}</p>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Row>
          <Col xl={12} lg={12} md={12}>
            <Card className="ps-card-display">
              <CardHeader className="d-flex align-items-center justify-content-between ps-bg-gradient">
                Data Information
              </CardHeader>
              <CardBody>
                <Row form>
                  <Col lg={4}>
                    <Label>Model</Label>
                    <p>{data.model}</p>
                  </Col>
                  <Col lg={4}>
                    <Label>Serial No</Label>
                    <p>{data.serial}</p>
                  </Col>
                  <Col lg={4}>
                    <Label>Install Date</Label>
                    <p>{data.install_date}</p>
                  </Col>
                  <Col lg={4}>
                    <Label>Brand</Label>
                    <p>{data.brand}</p>
                  </Col>
                  <Col lg={4}>
                    <Label>Postal Code</Label>
                    <p>{data.postal_code}</p>
                  </Col>
                  <Col lg={4}>
                    <Label>Unit</Label>
                    <p>{data.unit}</p>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>

        <Row>
          <Col xl={12} lg={12} md={12}>
            <Card className="ps-card-display main">
              <CardBody>
                <Nav tabs className="ps-tab">
                  {this.state.tabList.map((item, index) => {
                    return (
                      <NavItem key={item.name}>
                        <NavLink
                          className={classnames({
                            active: activeTab === (index + 1).toString(),
                          })}
                          onClick={() => {
                            this.toggleTab((index + 1).toString());
                          }}
                        >
                          {item.name}
                        </NavLink>
                      </NavItem>
                    );
                  })}
                </Nav>

                <TabContent activeTab={activeTab}>
                  <TabPane tabId="1" className="py-3">
                    <ContractTable state={this.state} toggle={this.toggle} />
                  </TabPane>
                  <TabPane tabId="2" className="py-3">
                    <RecordTable state={this.state} />
                  </TabPane>
                </TabContent>
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Modal isOpen={this.state.modal} toggle={this.toggle()} centered>
          <ModalHeader>Edit Contract</ModalHeader>

          <Form onSubmit={this.handleSubmit}>
            <ModalBody>
              <FormGroup>
                <Label>Left Session</Label>
                <Input
                  name="selectedSession"
                  value={this.state.selectedSession}
                  onChange={this.changeHandler}
                  required
                />
              </FormGroup>
              <FormGroup>
                <Label>End Date</Label>
                <Input
                  type="date"
                  name="selectedDate"
                  value={this.state.selectedDate}
                  onChange={this.changeHandler}
                  required
                />
              </FormGroup>
            </ModalBody>
            <ModalFooter>
              <Button type="submit">Save</Button>
            </ModalFooter>
          </Form>
        </Modal>
      </Page>
    );
  }
}

export default PosOrderContractDetailPage;
